import { createSlice } from "@reduxjs/toolkit";
// THUNK

const initialState = {
  payload: null,
  refreshStatus: [],
  isRefreshDSAPI: false,
};

// SLICE
export const dataSourcePayloadSlice = createSlice({
  name: "dataSourcePayload",
  initialState,
  reducers: {
    setDataSourcePayload: (state, action) => {
      state.payload = action.payload;
    },
    reset: () => initialState,
    setDataSourceRefreshStatus: (state, action) => {
      if (action.payload.refreshStatus !== undefined) {
        state.refreshStatus = action.payload.refreshStatus;
      }

      if (action.payload.isRefreshDSAPI !== undefined) {
        state.isRefreshDSAPI = action.payload.isRefreshDSAPI;
      }
    },
  },
});

// ACTION
export const { reset, setDataSourcePayload, setDataSourceRefreshStatus } =
  dataSourcePayloadSlice.actions;

// REDUCER
export default dataSourcePayloadSlice.reducer;
